<template lang="pug">
  .panel-page
    .panel.mx-auto.body-1
      h1 Edit Status & Permissions
      AccountSection.mt-4(message="STATUS & PERMISSIONS")
        form(
          @submit.prevent="submit"
          autocomplete="off"
        )
          .form-row
            .col-6
              .form-group
                label(for="user-level") User Level
                select.form-control#user-level(
                  v-model="userLevel"
                )
                  option(value="basic") Basic
                  option(value="agency_admin") Agency Admin
                  option(value="agency_admin_exc") Agency Admin (Exception)
                  option(value="state_admin") State Admin
                  option(value="state_admin_exc") State Admin (Exception)
                  option(value="naddi_admin") NADDI Admin
                  option(value="internal_admin") Internal Admin
          .form-row.mt-4
            .col-6
              .form-group
                label(for="user-role") User Role
                div
                  CustomRadio#user-role(
                    v-model="sworn"
                    :model-value="true"
                  ) Sworn Personnel
                div.mt-1
                  CustomRadio(
                    v-model="sworn"
                    :model-value="false"
                  ) Non-Sworn Personnel (Civilian)
          .form-row.mt-4
            .col
              .form-group
                label(for="ice-agent") Is this user a U.S. Immigration and Customs Enforcement (ICE) Agent?
                div
                  CustomRadio#ice-agent(
                    v-model="iceAgent"
                    :model-value="false"
                  ) No
                div.mt-1
                  CustomRadio(
                    v-model="iceAgent"
                    :model-value="true"
                  ) Yes
          .form-row.mt-4
            .col
              .form-group
                label(for="account-status") Account Status
                div(v-if="status != 'locked'")
                  CustomRadio#account-status(
                    v-model="status"
                    model-value="active"
                  ) Active
                div.mt-1(v-if="status != 'locked'")
                  CustomRadio(
                    v-model="status"
                    model-value="revoked"
                  ) Revoked
                div.body-1(v-if="status === 'locked'")
                  p The account status is locked. Please reset the user's password to change the account status.
          .form-row.mt-4
            .col
              button.btn.btn-primary(type="submit") Save Changes
              router-link.btn.btn-light.ml-3(
                :to="{name: 'user_search_view', query: {id: $route.query.id}}"
              ) Cancel
</template>

<script>
import CustomRadio from '@/components/CustomRadio'
import AccountSection from '@/components/AccountSection'
import { getUserInfo, updateUserStatus } from '@/lib/services/useradmin'
import { globalSuccess } from '@/lib/utils'

export default {
  name: 'AdminEditStatus',
  data() {
    return {
      iceAgent: false,
      sworn: false,
      userLevel: '',
      status: '',
    }
  },
  methods: {
    submit() {
      updateUserStatus(
        this.$route.query.id,
        this.userLevel,
        this.sworn,
        this.status,
        this.iceAgent,
      )
        .then(() =>
          this.$router.push({
            name: 'user_search_view',
            query: { id: this.$route.query.id },
          }),
        )
        .then(() =>
          globalSuccess(null, 'User information was successfully updated.'),
        )
        .then(() => scrollTo(0, 0))
    },
  },
  beforeRouteEnter(to, _from, next) {
    getUserInfo(to.query.id).then(resp =>
      next(vm => {
        vm.userLevel = resp.data.userLevel
        vm.status = resp.data.status
        vm.sworn = resp.data.sworn
        vm.iceAgent = resp.data.iceAgent
      }),
    )
  },
  components: { AccountSection, CustomRadio },
}
</script>

<style lang="scss" scoped>
</style>
